// Bileli · shared/lib — hand-off from Bileli pages into Telegram's own SETTINGS screens (profile/avatar
// editing, interface language, sessions… all live in the Telegram half). Same seam pattern as
// openTelegramDm/openCourseSpace: flip to chat mode FIRST (the left column only exists there), then drive
// Telegram's stock actions — zero vendored edits.

import { getActions } from '../../../global';

import type { SettingsScreens } from '../../../types';

export function openTelegramSettings(screen?: SettingsScreens): void {
  const { setSharedSettingOption, openSettingsScreen } = getActions();
  setSharedSettingOption({ activeMode: 'chat' });
  openSettingsScreen({ screen });
}
